import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-higiene-vermes',
  templateUrl: './higiene-vermes.component.html',
  styleUrls: ['./higiene-vermes.component.css']
})
export class HigieneVermesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
